import React from 'react';

type Props = {
  title: string;
  children: any;
};

const ReportItem = ({ title, children }: Props) => {
  return (
    <div style={{ backgroundColor: 'white', borderRadius: 10, minHeight: 100, boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;' }}>
      <div
        style={{
          padding: 10,
          fontSize: 18,
          fontWeight: 'bold',
          borderTopRightRadius: 10,
          borderTopLeftRadius: 10,
        }}
      >
        {title}
      </div>
      <div style={{ borderBottomLeftRadius: 10, borderBottomRightRadius: 10, padding: 10 }}>{children}</div>
    </div>
  );
};

export default ReportItem;
